import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CentralPermissions } from '@portal-core/permissions/enums/central-permissions.enum';
import { PermissionsService } from '@portal-core/permissions/services/permissions.service';
import { FlareXmlEditorMode } from '@portal-core/project-files/types/flare-xml-editor-mode.type';
import { InputObservable } from '@portal-core/util/input-observable.decorator';
import { map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'mc-collab-doc-bar',
  templateUrl: './collab-doc-bar.component.html',
  styleUrls: ['./collab-doc-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollabDocBarComponent implements OnInit {
  @Input() docSize?: number;
  @Input() lineCount?: number;
  @Input() mode?: FlareXmlEditorMode;
  /** The project id for the collab doc. Used to check if the user has permission to edit code. And then display a message in the bar if they cannot. */
  @Input() projectId: number;
  /** Whether or not to show the items in the toolbar. This can be used to hide the items until all the necessary data is loaded. */
  @Input() showItems?: boolean = true;

  @InputObservable('projectId') projectId$: Observable<number>;

  /** An observable for whether to show a message to the user that they can't edit the code. */
  showCannotEditCodeMessage$: Observable<boolean>;
  /** An observable for whether to show a message to the user that they can't edit the file. */
  showCannotEditFileMessage$: Observable<boolean>;

  constructor(private permissionsService: PermissionsService) { }

  ngOnInit() {
    this.showCannotEditCodeMessage$ = this.projectId$.pipe(
      switchMap(projectId => this.permissionsService.currentUserHasPermission$(CentralPermissions.EditCode, projectId).pipe(map(hasPermission => !hasPermission)))
    );

    this.showCannotEditFileMessage$ = this.projectId$.pipe(
      switchMap(projectId => this.permissionsService.currentUserHasPermission$(CentralPermissions.CreateEditFiles, projectId).pipe(map(hasPermission => !hasPermission)))
    );
  }
}
